var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "140px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "单位", prop: "companyId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择单位"
                          },
                          model: {
                            value: _vm.childData.companyId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "companyId", $$v)
                            },
                            expression: "childData.companyId"
                          }
                        },
                        _vm._l(_vm.companyList, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.companyName, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "长期订场开始日期", prop: "startTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          placeholder: "请选择订场开始日期"
                        },
                        model: {
                          value: _vm.childData.startTime,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "startTime", $$v)
                          },
                          expression: "childData.startTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "长期订场结束日期", prop: "endTime" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          clearable: "",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd",
                          type: "date",
                          placeholder: "请选择订场结束日期"
                        },
                        model: {
                          value: _vm.childData.endTime,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "endTime", $$v)
                          },
                          expression: "childData.endTime"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订场时间", prop: "week" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择订场时间"
                          },
                          model: {
                            value: _vm.childData.week,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "week", $$v)
                            },
                            expression: "childData.week"
                          }
                        },
                        _vm._l(_vm.statusOptions, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: { label: item.dicName, value: item.dicValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "场地", prop: "placeIdsList" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            multiple: "",
                            placeholder: "请选择场地"
                          },
                          on: { change: _vm.changePlace },
                          model: {
                            value: _vm.childData.placeIdsList,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "placeIdsList", $$v)
                            },
                            expression: "childData.placeIdsList"
                          }
                        },
                        _vm._l(_vm.placeOptions, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.areaName + item.placeName,
                              value: item.id,
                              disabled: _vm.shouldDisable(item.areaId)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间段", prop: "periodName" } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticClass: "mytextarea",
                            staticStyle: {
                              width: "100%",
                              "min-height": "36px !important"
                            },
                            attrs: {
                              type: "textarea",
                              readonly: "",
                              autosize: "",
                              resize: "none",
                              placeholder: "请选择时间段"
                            },
                            model: {
                              value: _vm.childData.periodName,
                              callback: function($$v) {
                                _vm.$set(_vm.childData, "periodName", $$v)
                              },
                              expression: "childData.periodName"
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "90px",
                                "margin-left": "10px",
                                height: "36px"
                              },
                              attrs: { icon: "el-icon-search" },
                              on: { click: _vm.choosePlace }
                            },
                            [_vm._v("选择")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          maxlength: "200",
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "remark", $$v)
                          },
                          expression: "childData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择",
            visible: _vm.dialogFormVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("chooseTime", {
            attrs: {
              "key-value": _vm.areaId,
              periodIdList: _vm.periodIdList,
              "show-dialog": _vm.dialogFormVisible
            },
            on: {
              handCancle: _vm.handCancleTime,
              handCreate: _vm.handCreateTime
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }